import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';

export const RecordingTips: React.FC = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const tips = [
    {
      title: 'Duration',
      description: 'Your video can be up to 30 seconds long.'
    },
    {
      title: 'Lighting',
      description: 'Use natural or soft lighting to keep the subject well-lit. Avoid shadows or harsh lights.'
    },
    {
      title: 'Background',
      description: 'Choose a simple, uncluttered background that contrasts with your clothing for better focus.'
    },
    {
      title: 'Movement',
      description: 'Keep movements smooth and minimal to maintain video quality.'
    },
    {
      title: 'Clarity',
      description: 'Ensure your face is clearly visible and avoid obstructions like hats or sunglasses.'
    },
    {
      title: 'Audio',
      description: 'Speak clearly and keep background noise to a minimum for better lip-sync accuracy.'
    },
    {
      title: 'Stability',
      description: 'Use a tripod or steady your camera to avoid shaky footage.'
    }
  ];

  return (
    <div className="mb-8">
      <h3 className="text-2xl font-bold text-gray-900 mb-4">Recording Tips 📹</h3>
      <p className="text-gray-600 mb-4">
        Before uploading, follow these guidelines to ensure the best results:
      </p>
      
      <div className="space-y-4">
        {tips.slice(0, isExpanded ? tips.length : 3).map((tip, index) => (
          <motion.div
            key={tip.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className="bg-red-50 rounded-lg p-4"
          >
            <h4 className="font-semibold text-gray-900">{tip.title}</h4>
            <p className="text-gray-600">{tip.description}</p>
          </motion.div>
        ))}
      </div>

      <button
        onClick={() => setIsExpanded(!isExpanded)}
        className="mt-4 text-red-600 font-medium flex items-center hover:text-red-700 transition-colors"
      >
        {isExpanded ? 'Show Less' : 'Learn More About Recording Tips'}
        <ChevronDown
          className={`ml-1 w-4 h-4 transform transition-transform ${
            isExpanded ? 'rotate-180' : ''
          }`}
        />
      </button>
    </div>
  );
};